import { createFileRoute } from '@tanstack/react-router';
import { DocumentsPage } from '../features/documents/DocumentsPage';
import { validateDocumentsSearch } from '../features/documents/search';

export const Route = createFileRoute('/documents')({
  validateSearch: validateDocumentsSearch,
  component: DocumentsPage,
});
